import { lazy } from "common/load/componentUtils";

import { useDrawer } from "client/common/hooks/stackables";

import type { PromotionDrawerProps } from "../components/PromotionDrawer";

const PromotionDetailDrawer = lazy(() => import("../components/PromotionDrawer"));
const BiFreeToyDrawer = lazy(() => import("../components/BiFreeToyDrawer"));

export const useBiFreeToyDrawer = () => {
  const { open } = useDrawer();
  return {
    open: () => open(BiFreeToyDrawer),
  };
};

export const usePromotionDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: PromotionDrawerProps) => open(PromotionDetailDrawer, props),
  };
};
